.contentContainer {
    display: flex;
    justify-content: space-evenly;
}